import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { AssetInQuestionResponse } from '../models/assets-in-base-asset/AssetInQuestionResponse';

import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'AssetInQuestionResponse';

@Injectable({
  providedIn: 'root'
})
export class ApiAssetInQuestionResponseService {

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getAssetsInQuestionResponse(): Observable<AssetInQuestionResponse[]> {
    const url = apiUrl + '/GetAssetsInQuestionResponse';
    return this.http.get<AssetInQuestionResponse[]>(url).pipe();
  }

  getAssetInQuestionResponse(id: number): Observable<AssetInQuestionResponse> {
    const url = `${apiUrl}/GetAssetInQuestionResponse/${id}`;
    return this.http.get<AssetInQuestionResponse>(url).pipe();
  }

  getAssetsInQuestionResponseWithLinkedQuestionResponseId(linkedQuestionResponseId: number): Observable<AssetInQuestionResponse[]> {
    const url = `${apiUrl}/GetAssetsInQuestionResponseWithLinkedQuestionResponseId/${linkedQuestionResponseId}`;
    return this.http.get<AssetInQuestionResponse[]>(url, httpOptions).pipe();
  }

  getAssetsInQuestionResponseWithSceneAssetRelationId(id: number): Observable<AssetInQuestionResponse[]> {
    const url = `${apiUrl}/GetAssetsInQuestionResponseWithSceneAssetRelationId/${id}`;
    return this.http.get<AssetInQuestionResponse[]>(url, httpOptions).pipe();
  }

  addAssetInQuestionResponse(AssetInQuestionResponse: AssetInQuestionResponse): Observable<AssetInQuestionResponse> {
    const url = apiUrl + '/PostAssetInQuestionResponse';
    return this.http.post<AssetInQuestionResponse>(url, AssetInQuestionResponse, httpOptions).pipe();
  }

  updateAssetInQuestionResponse(id: number, AssetInQuestionResponse: AssetInQuestionResponse): Observable<AssetInQuestionResponse> {
    const url = `${apiUrl}/PutAssetInQuestionResponse/${id}`;
    return this.http.put(url, AssetInQuestionResponse, httpOptions).pipe(
      tap((AssetInQuestionResponseRes: AssetInQuestionResponse) => true ), //console.log()),
      catchError(this.handleError<AssetInQuestionResponse>('updateAssetInQuestionResponse'))
    )
  }

  deleteAssetInQuestionResponse(id: number): Observable<AssetInQuestionResponse> {
    const url = `${apiUrl}/DeleteAssetInQuestionResponse/${id}`;
    return this.http.delete<AssetInQuestionResponse>(url, httpOptions).pipe();
  }

  deleteAssetInQuestionResponseWithLinkedQuestionResponseId(id: number): Observable<AssetInQuestionResponse> {
    const url = `${apiUrl}/DeleteAssetInQuestionResponseWithLinkedQuestionResponseId/${id}`;
    return this.http.delete<AssetInQuestionResponse>(url, httpOptions).pipe();
  }

  assetInQuestionResponseExists(id: number): Observable<boolean> {
    const url = `${apiUrl}/AssetInBaseAssetExists/${id}`;
    return this.http.get<boolean>(url, httpOptions).pipe();
  }
}
